<div class="col-xxl-8 box-col-8">
  <div class="card">
    <div class="card-head d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <div class="card-head-text h5 mb-0">My Learnings</div>
      </div>

      <button class="view-button h5" (click)="goToAllLearnings()">View all <i
          class="fa fa-angle-double-right"></i></button>
    </div>
    <hr>
    <div class="card-content p-3">
      <span class="Courses-0 head-helper fw-500 h5" *ngIf="learnings?.length===0">No Recent Programs</span>

      <p-carousel [class.custom_carousel]="learnings?.length <= 3" #carousel [value]="learnings" [numVisible]="3"
        [numScroll]="1" [showIndicators]="false" [showNavigators]="false">
        <ng-template let-learning pTemplate="item">
          <div class="card border program-card">
            <img class="card-image"
              [src]="learning.url?learning.url : '../../../../assets/images/employeeCareer/code.jpg'"
              alt="Program Image" crossorigin="anonymous">
            <div class="program-card-content p-3">
              <p class="program-name h5" matTooltip="{{learning?.programName}}">{{learning?.programName}}</p>
              <div class="d-flex justify-content-between program-details">
                <div class="col-8  pl-0 pr-0 program-inner-details">
                  <i class="fa fa-caret-square-o-right"></i>
                  <span class="pl-2 h5">{{learning?.totalCourses}} Courses</span><br>
                  <i class="fa fa-list-alt"></i>
                  <span class="pl-2 h5">{{learning?.totalTopics}} Topics</span>
                </div>
                <div class="program-button-container mr-3">
                  <button class="play-button h5" (click)="goToPrograms(learning)"><i class="fa fa-play"></i></button>
                </div>
              </div>
              <mat-progress-bar class="progress-bar mt-3" mode="determinate"
                [value]="0 || programProgress[learning?.programID]"
                [matTooltip]="programProgress[learning?.programID] + ' %'"></mat-progress-bar>
            </div>
          </div>
        </ng-template>
      </p-carousel>

      <div class="d-flex justify-content-end" style="position: absolute;bottom: 5px;right: 10px;"
        *ngIf="learnings?.length>0">
        <button [disabled]="currentCarouselItem < 4" (click)="navigateBackward($event)" class="navigate-button pr-2"><i
            class="fa fa-angle-left cursor-pointer" [class.disabled-button]="currentCarouselItem < 4"></i></button>
        <button [disabled]="currentCarouselItem >= learnings?.length" (click)="navigateForward($event)"
          class="navigate-button"><i class="fa fa-angle-right cursor-pointer"
            [class.disabled-button]="currentCarouselItem >= learnings?.length"></i></button>
      </div>
    </div>
  </div>
</div>
